var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textview",class:{'flat': _vm.flat}},_vm._l((_vm.asHeadingsAndColumns),function(group){return _c('div',{key:group.id,class:[group[0].isHeading ? 'other' :'paragraph']},[_c('prismic-rich-text',{staticClass:"prismic",attrs:{"field":group}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }